import React from 'react';
import ReactMarkdown from 'react-markdown';
import './Message.css';

const Message = ({ message }) => {
  if (!message || typeof message !== 'object') {
    return null;
  }

  return (
    <div className={`message ${message.role}`}>
      <div className="message-content">
        <ReactMarkdown>{message.content || ''}</ReactMarkdown>
      </div>
      <div className="message-footer">
        <div className="message-info">
          {message.role === 'assistant' && message.model && (
            <span className="model-tag">{message.model}</span>
          )}
          <span className="message-timestamp">
           {new Date(message.timestamp).toLocaleTimeString()}
         </span>
        </div>
      </div>
    </div>
  );
};

export default Message;